import request from '../utils/request';

export function getSystemConfigs(params) {
    return request.get('/config', params);
}

export function updateSystemConfig(params) {
    return request.patch('/config', params);
}

export function getInviteCode(params) {
    return request.get('/invite/code/list', params)
}

export function createInviteCode(params) {
    return request.post('/invite/code/create', params)
}

export function deleteInviteCode(ids) {
    return request.dataDel(`/invite/code/delete?ids=${ids}`);
}

export function updateInviteCode(params) {
    return request.patch('/invite/code/update', params)
}

export function getWhitelist(params) {
    return request.get('/invite/whitelist/list', params);
}

export function createWhitelist(params) {
    return request.post('/invite/whitelist/create', params);
}

export function updateWhitelist(params) {
    return request.patch('/invite/whitelist/update', params);
}

export function deleteWhitelist(ids) {
    return request.dataDel(`/invite/whitelist/delete?ids=${ids}`);
}

export function getAppVersion() {
    return request.get('/app/version')
}

export function updateAppVersion(params) {
    return request.patch('/app/version', params);
}

export function getVersionNotes(params) {
    return request.get('/version/bulletin', params);
}

export function createVersionNote(params) {
    return request.post('/version/bulletin/create', params);
}

export function updateVersionNote(params) {
    return request.patch('/version/bulletin/edit', params);
}

export function deleteVersionNote(id) {
    return request.dataDel(`/version/bulletin?id=${id}`);
}

export function uploadUserTags(tags, params) {
    return request.post(`/upload/tag/user?tags=${tags}`, params);
}

export function getPlanConfig() {
    return request.get('/subscription/plan-config/get');
}

export function updatePlanConfig(params) {
    return request.patch('/subscription/plan-config/update', params);
}

export function getCreditsPlanConfig() {
    return request.get('/credits/plan-config/get');
}

export function updateCreditsPlanConfig(params) {
    return request.patch('/credits/plan-config/update', params);
}

export function getOrgSubscriptionPlanConfig() {
    return request.get('/organization-subscription/plan-config/get');
}

export function updateOrgSubscriptionPlanConfig(params) {
    return request.patch('/organization-subscription/plan-config/update', params);
}

export function getOrgCreditsPlanConfig() {
    return request.get('/organization-credits/plan-config/get');
}

export function updateOrgCreditsPlanConfig(params) {
    return request.patch('/organization-credits/plan-config/update', params);
}

export function getPromotionCampaigns(params) {
    return request.get('/promotion/campaign/list', params);
}

export function getPromotionCampaign(id) {
    return request.get('/promotion/campaign/get', { id });
}

export function createPromotionCampaign(params) {
    return request.post('/promotion/campaign/create', params);
}

export function updatePromotionCampaign(params) {
    return request.patch('/promotion/campaign/update', params);
}

export function deletePromotionCampaign(ids) {
    return request.dataDel(`/promotion/campaign/delete?ids=${ids}`);
}

export function retryPromotionProvisioning(params) {
    return request.post('/promotion/provisioning/retry', params);
}

export function getPromotionCodes(params) {
    return request.get('/promotion/code/list', params);
}

export function getPromotionCode(id) {
    return request.get('/promotion/code/get', { id });
}

export function createPromotionCode(params) {
    return request.post('/promotion/code/create', params);
}

export function updatePromotionCode(params) {
    return request.patch('/promotion/code/update', params);
}

export function deletePromotionCode(ids) {
    return request.dataDel(`/promotion/code/delete?ids=${ids}`);
}
